
<template>

  <div>

    <el-container>
      <el-header>
        <el-card  style="height:300px;width: 41%;margin:0 auto;">
          <el-descriptions class="margin-top" title="登录信息" :column="3"  border>
            <template slot="extra">
              <el-button type="primary" v-on:click="GetPlan"  size="small">批量搭建</el-button>
              <el-button type="primary" v-on:click="GetRo"  size="small">刷新</el-button>
              <el-button type="primary" v-on:click="findIds"  size="small">查询</el-button>
            </template>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                姓名
              </template>
              <div class="block">
                <!--              <el-cascader-->
                <!--                v-model="names"-->
                <!--                :options="name"-->
                <!--                filterable></el-cascader>-->
                <el-select v-model="username" filterable placeholder="请选择">
                  <el-option
                    v-for="(items,i) in listname"
                    :key="i"
                    :value="items.username">
                  </el-option>
                </el-select>
              </div>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                登录二代
              </template>
              微驰
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-location-outline"></i>
                账户列表
              </template>

              <el-select v-model="towName" filterable placeholder="请选择">
                <el-option
                  v-for="(items,i) in two"
                  :key="i"
                  :value="items.twoname">
                </el-option>
              </el-select>

            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                广告主账户列表
              </template>
              <!--            <el-select v-model="idsname" placeholder="请选择">-->
              <!--              <el-option-->
              <!--                v-for="(items,i) in idsList"-->
              <!--                :key="i"-->
              <!--                :value="items.idsname">-->
              <!--              </el-option>-->
              <!--            </el-select>-->
              <el-tag :key="i" v-for="(item,i) in idsList">{{item.idsname}}</el-tag>

            </el-descriptions-item>
          </el-descriptions>
        </el-card>
      </el-header>
      <el-container>
        <el-aside width="1000px" >
          <div style="height:500px;position: absolute;left:200px;top: 320px">
            <el-steps direction="vertical" :active="1">
              <el-step process-status="success" title="创建计划"></el-step>
              <el-step title="创建广告组"></el-step>
              <el-step process-status="success"	 title="创建广告" description="需要上传图片素材"></el-step>
            </el-steps>
          </div>




        </el-aside>
        <el-container>
          <el-main style="height: 800px;width:1000px">
            <!--          搭建计划代码-->
            <el-card class="box-card1" style="height:30%;">

              <div slot="header" class="clearfix">
                <el-form label-position="right"  :model="formLabelAlign">
                  <el-form-item  label="计划名称:">
                    <el-input style="width: 200px" v-model="formLabelAlign.name"></el-input>
                  </el-form-item>


                  <el-form-item label="计划开关:">
                    <el-switch
                      v-model="flag"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>

                </el-form>
              </div>

            </el-card>
            <el-card class="box-card000" style="height:40%;">

              <div slot="header" style="margin-left: 0px" class="clearfix">

                <el-form label-position="right" :model="formLabelAlign1">

                  <el-form-item label="二阶出价:" style="margin-top: 20px">
                    <el-input style="width: 100px;"  v-model="formLabelAlign1.ocpxPrice"></el-input>元
                  </el-form-item>

                  <el-form-item label="性别:">
                    <el-radio-group v-model="sex">
                      <el-radio-button label="男"></el-radio-button>
                      <el-radio-button label="女"></el-radio-button>
                      <el-radio-button label="不限"></el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="地域定向">
                    <el-switch
                      v-model="RGOT"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="年龄(不选即不限):">
                    <div>
                      <el-checkbox-group v-model="age">
                        <el-checkbox-button v-for="(item,i) in ages"  :label="i+1" :key="i" >{{item.value}}</el-checkbox-button>
                      </el-checkbox-group>
                    </div>
                  </el-form-item>
                </el-form>
              </div>

            </el-card>
            <el-card class="box-card3" style="height:70%;">

              <div slot="header" class="clearfix">
                <el-form label-position="right"  :model="formLabelAlign3">
                  <el-form-item  label="展现形式:">
                    <!--                  <el-select v-model="formLabelAlign3.placeType" placeholder="请选择">-->
                    <!--                    <el-option-->
                    <!--                      v-for="item1 in options4"-->
                    <!--                      :key="item1.value"-->
                    <!--                      :label="item1.label"-->
                    <!--                      :value="item1.value">-->
                    <!--                    </el-option>-->
                    <!--                  </el-select>-->
                    <el-cascader
                      v-model="formLabelAlign3.placeType"
                      :options="options4"
                      filterable></el-cascader>
                  </el-form-item>
                  <el-form-item label="标题打乱(默认关闭):">
                    <el-switch
                      v-model="daluan"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="程序化创意(3条文案)">
                    <el-switch
                      v-model="cxhcy"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="*产品名:" style="margin-top: 20px">
                    <el-input
                                style="width: 200px;"  v-model="formLabelAlign3.productName"></el-input>
                  </el-form-item>
                  <el-form-item label="标题1：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[0]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题2：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[1]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题3：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[2]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题4：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[3]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题5：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[4]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题6：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[5]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题7：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[6]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题8：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[7]"></el-input>
                  </el-form-item>



                </el-form>
              </div>

            </el-card>
            <!--          图片素材代码-->
            <el-card class="box-cards" style="height:15%;">
              <div slot="header" class="clearfix">
                <span >批量搭建任务进度</span>
              </div>
              <el-row>
                <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"  status="success" :percentage="percentages"></el-progress>
              </el-row>
              <!--          <el-dialog :visible.sync="dialogVisible">-->
              <!--            <img width="20%" :src="dialogImageUrl" alt="">-->
              <!--          </el-dialog>-->
            </el-card>
            <el-tabs class="box-card" v-model="updateType" >
              <el-tab-pane label="图片素材" name="first">
                <el-card class="box-card" style="height:90%;">
                  <div slot="header" class="clearfix">
                    <span >素材上传工作区</span>
                  </div>
                  <el-row>
                    <el-upload
                      ref="upload"
                      action="#"
                      scoped-slot="text"
                      list-type="picture-card"
                      :on-preview="handlePictureCardPreview"
                      :auto-upload="false"
                      :limit="9"
                      :file-list="fileList"
                      :multiple="true"
                      :on-change='onChange'
                      :on-remove="handleRemove">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"  status="success" :percentage="percentage"></el-progress>

                  </el-row>

                  <el-button type="primary"  @click="clearfile" size="small">一键清除</el-button>
                </el-card>
              </el-tab-pane>
              <el-tab-pane label="视频素材" name="second">
                <el-card class="box-card" style="height:90%;">
                  <div slot="header" class="clearfix">
                    <span >视频素材上传工作区</span>
                  </div>
                  <el-row>
                    <el-upload
                      ref="upload"
                      action="#"
                      scoped-slot="text"
                      :on-preview="handlePictureCardPreview2"
                      :auto-upload="false"
                      :limit="9"
                      :multiple="true"
                      :file-list="VideofileList"
                      :on-change='onChange2'
                      :on-remove="handleRemove2">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"  status="success" :percentage="percentage"></el-progress>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="20%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                  </el-row>
                </el-card>
              </el-tab-pane>

            </el-tabs>

          </el-main>

        </el-container>
      </el-container>
    </el-container>






  </div>

</template>

<script>
import axios from "axios";
import sha1 from 'js-sha1';
import {Base64} from 'js-base64';
import qs from 'qs';
export default {
  data() {

    const c1=[{
      id:1,
      value:'0-18岁'
    },
      {
        id:2,
        value:'18-24岁'
      },
      {
        id:3,
        value:'25-29岁'
      },
      {
        id:4,
        value:'30-34岁'
      },
      {
        id:5,
        value:'35-49岁'
      },
      {
        id:6,
        value: '50岁及以上'
      },
    ]
    return {
      cxhcy:false,
      ages : c1,
      daluan:false,
      flag:false,
      updateType:'',
      listname:[],
      time_list:'',
      timeList:[{
        value:'111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
        label:'全天投放'
      },
        {
          value:'000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111',
          label:'五点'
        },
        {
          value:'000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111',
          label:'六点'
        },
        {
          value:'000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111',
          label:'七点'
        },
        {
          value:'000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111',
          label:'八点半'
        },
        {
          value:'000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111',
          label:'九点后'
        },
        {
          value:'000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111',
          label:'九点半'
        },
        {
          value:'000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111',
          label:'十点'
        },
        {
          value:'000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111',
          label:'十点半'
        },
        {
          value:'000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111',
          label:'十一点'
        },{
          value:'000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111',
          label:'十四点'
        },
        {
          value:'000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111',
          label:'十六点'
        },
        {
          value:'000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111',
          label:'十七点'
        },
        {
          value:'000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111',
          label:'十八点'
        }],
      names:'',
      idsname:[],
      option1: [{
        value: '1',
        label: '非应用商店'
      },
        {
          value: '2',
          label: '广告联盟'
        }],

      options3: [{
        value: '4',
        label: '表单提交'
      }, {
        value: '7',
        label: '添加到桌面'
      },{
        value: '12',
        label: '自定义付费'
      }],
      options4: [{
        value: '1',
        label: '信息流',
        children: [{
          value: '1',
          label: '横板大图',
        },
          {
            value: '63',
            label: '竖板视频'
          },
          {
            value: '60',
            label: '横板视频'
          }]
      },


      ],
      sex:'不限',
      age:[],
      sexList:[],

      ageIdList:[],
      value: '',
      formLabelAlign: {
        name: '',
        mediaType: '',
      },
      formLabelAlign1: {
        name: '',
        cvType: '',
        ocpxPrice: ''
      },
      normId:[61,4,3],
      formLabelAlign3: {
        placeType: '',
        title: [],
        productName:'',
      },
      percentage:0,
      percentages:0,
      fileList: [],
      VideofileList: [],
      age2:'',
      creativeList:[],
      arr:{},
      targetId:'',
      idsList:[
        {
          id:'',
          username:'',
          ids:'',
          twoname:'',
          url:'',
          xiaoshuourl:'',
          token:'',
          idsname:'',
          planId:'',
          groundId:'',
          planName:'',
          pageId:'',
          pageUrl:'',
          ocpcType:'',
          haplink:'',
          appid:''

        }
      ],
      flagt:0,
      sex1:'',
      dxid:'',
      addList:[],

      creativeReqs:[],
      dialogImageUrl: '',
      dialogVisible: false,
      RGOT:false,
      fileCode:[],
      videofileCode:[],
      two:[{
        id:'',
        twoname:'',
      }],
      // towToken:[],
      towName:'',
      username:'',
    };
  },
  methods: {
    clearfile(){
      let arr1 =[this.fileList[0]];
      this.fileList = arr1
      this.VideofileList=[]
    },
    shuffle(arr){
      var l = arr.length
      var index, temp
      while(l>0){
        index = Math.floor(Math.random()*l)
        temp = arr[l-1]
        arr[l-1] = arr[index]
        arr[index] = temp
        l--
      }
      return arr
    },
    async GetPlan(){
      this.sexList=[];
      if (this.sex==="女"){
        this.sex1='1'
      }else if (this.sex==="男"){
        this.sex1='2'
      }

      if (this.age.length===0){
        this.age2='1,2,3,4,5,6'
      }else {

        this.age2=this.age.join(",")

      }

      let t=0;
      if (this.formLabelAlign3.placeType[1]==="1"){
        for (let key in this.idsList){
          let time1 = parseInt(new Date().getTime()) + '';
          console.log(parseInt(time1/1000))
          time1=parseInt(time1/1000);
          let sign= sha1(this.idsList[key].apiid + this.idsList[key].apikey + time1);
          let token=Base64.encode(this.idsList[key].ownerid + "," + this.idsList[key].apiid + "," + time1 + "," + sign);
          this.fileCode=[]
          let parms={
            name:this.idsList[key].planName,
            mediaType:this.formLabelAlign.mediaType,
            id:key,
            token:token,
            idsname:this.idsList[key].idsname
          }
          await this.upload(parms)
          await this.plan(parms)
          // await this.queryWebsideId(parms)
          await this.dingxiang(parms)
          let groundData={
            name:this.idsList[key].planName,
            token:token,
            planId:this.idsList[key].planId,
            adGroupName:this.idsList[key].planName,
            id:key,
            dayLimit:0,
            extensionFlow:1,
            extensionType:7,
            flowScene:6,
            ocpcOptmType:2,
            billingType:5,
            ocpcPrice:this.formLabelAlign1.ocpxPrice*100,
            ocpcType:6,
            pageId:this.idsList[key].pageId,
            pageType:7,
            pageUrl:this.idsList[key].url,
            deepUrl:this.idsList[key].haplink,
            instantAppId:this.idsList[key].appid,
            instantAppUrl:this.idsList[key].url,
            price:300
          }
          // await this.stopPlan(groundData)
          await this.stopPlan(groundData)
          await this.ground(groundData)
          console.log("现在是广告组信息：")
          console.log(this.idsList[key])
          if (this.cxhcy == true) {
            let cxhparams = {
              adPlanId: this.idsList[key].planId,
              adGroupId: this.idsList[key].groundId,
              creativeReqs: [{  // 注意这里使用了数组包裹对象
                copywriterValues: this.formLabelAlign3.title,
                imgIds: this.fileCode.slice(1),
                brandLogoImgId: this.fileCode[0],
                brandName: this.formLabelAlign3.productName,
                globalSpecId: 1,
                globalSpecName: "横版大图",
                clickUrl: this.idsList[key].xiaoshuourl,
              }],
            };

            let cxh = {
              token: token,
              paramcxh: cxhparams,
            };
            await this.cxhguanggao(cxh)
          }else
          {
            this.addList=[];
            let t=0;
            for (let code=1;code<this.fileCode.length;code++){
              t=t+1;
              this.arr={}
              this.arr.adPlanId=this.idsList[key].planId;
              this.arr.adName="test";
              this.arr.adGroupId=this.idsList[key].groundId;
              this.arr.copywriter=this.formLabelAlign3.title[code-1];
              this.arr.brandName=this.formLabelAlign3.productName;
              this.arr.globalSpecId=this.formLabelAlign3.placeType[1];
              this.arr.adSource=1;
              this.arr.clickUrl=this.idsList[key].xiaoshuourl;
              this.arr.brandLogoImgId=this.fileCode[0];
              this.arr.imgMatIds=this.fileCode[code];
              this.addList[code-1]=this.arr
            }
            let t1={
              token:token,
              addList:this.addList,
              name:this.idsList[key].planName,
            }

            await this.guanggao(t1)
          }


          let num=100/this.idsList.length;
          this.percentages=num*(Number(key)+1);
          console.log(this.percentages)



        }
        if (this.percentages===100){
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }

      }
      else if (this.formLabelAlign3.placeType[1]==="63" || this.formLabelAlign3.placeType[1]==="60"){
        for (let key in this.idsList){

          let time1 = parseInt(new Date().getTime()) + '';
          console.log(parseInt(time1/1000))
          time1=parseInt(time1/1000);
          let sign= sha1(this.idsList[key].apiid + this.idsList[key].apikey + time1);
          let token=Base64.encode(this.idsList[key].ownerid + "," + this.idsList[key].apiid + "," + time1 + "," + sign);
          this.fileCode=[]
          let parms={
            name:this.idsList[key].planName,
            mediaType:this.formLabelAlign.mediaType,
            id:key,
            token:token,
            idsname:this.idsList[key].idsname
          }
          await this.upload(parms)
          await this.uploadVideo(parms)
          await this.plan(parms)
          // await this.queryWebsideId(parms)
          await this.dingxiang(parms)
          //停止计划
          let groundData={
            name:this.idsList[key].planName,
            token:token,
            planId:this.idsList[key].planId,
            adGroupName:this.idsList[key].planName,
            id:key,
            dayLimit:0,
            extensionFlow:1,
            extensionType:7,
            flowScene:6,
            ocpcOptmType:2,
            billingType:5,
            ocpcPrice:this.formLabelAlign1.ocpxPrice*100,
            ocpcType:6,
            pageId:this.idsList[key].pageId,
            pageType:7,
            pageUrl:this.idsList[key].url,
            deepUrl:this.idsList[key].haplink,
            instantAppId:this.idsList[key].appid,
            instantAppUrl:this.idsList[key].url,
            price:300
          }
          // await this.stopPlan(groundData)
          await this.stopPlan(groundData)

          await this.ground(groundData)
          console.log("现在是广告组信息：")
          console.log(this.idsList[key])
          this.addList=[];
          let t=0;
          for (let code=1;code<this.fileCode.length;code++){
            t=t+1;
            this.arr={}
            this.arr.adPlanId=this.idsList[key].planId;
            this.arr.adName="test";
            this.arr.adGroupId=this.idsList[key].groundId;
            this.arr.copywriter=this.formLabelAlign3.title[code-1];
            this.arr.brandName=this.formLabelAlign3.productName;
            this.arr.globalSpecId=this.formLabelAlign3.placeType[1];
            this.arr.clickUrl=this.idsList[key].xiaoshuourl;

            this.arr.adSource=1;
            console.log("图片code："+this.fileCode[code])
            this.arr.videoImgId=this.fileCode[code];
            this.arr.brandLogoImgId=this.fileCode[0];
            this.arr.videoMatIds=this.videofileCode[code-1];
            this.addList[code-1]=this.arr
            console.log(this.arr)
          }
          console.log(this.addList)

          let t1={
            token:token,
            addList:this.addList,
            name:this.idsList[key].planName,
          }

          await this.guanggao(t1)

          let num=100/this.idsList.length;
          this.percentages=num*(Number(key)+1);
          console.log(this.percentages)



        }
        if (this.percentages===100){
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }

      }




    },
    ro(){
      this.formLabelAlign3.title=[]

    },
    async findIds(){

      this.formLabelAlign3.title=[]

      this.idsList=[],
        await axios.post('https://test.nbweiou.cn/api/oppo/get_ids',{
          'username':this.username,
          'twoname':this.towName
        }).then(
          async res=>{
            console.log(res)
            this.idsList=res.data;
          },
        )
    },

    //刷新信息
    async GetRo(){

      console.log(this.formLabelAlign3.placeType[1])
      await axios.post('https://test.nbweiou.cn/api/oppo/get_vivo_user',{
        'username':this.username
      }).then(
        res=>{
          this.two=res.data
          // for (let key in res.data){
          //   this.twoName[key]=res.data[key].twoname
          //   this.towToken[key]=res.data[key].token
          // }
        }
      )


      console.log(this.formLabelAlign3.title)


    },
    //停止计划api
    async stopPlan(parms){
      let flag1=0;
      if (this.flag===false){
        flag1=1
      }else {
        flag1=0;
      }
      const config = {
        headers:{
          'Authorization': "Bearer "+parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      let parmm={
        planIds:parms.planId,
        status2:flag1
      }
      ///?extensionType=2&dayBudget=155500&planName=123&dayLimit=1
      await axios.post('apis/v3/plan/status',qs.stringify(parmm),config
      ).then(res => {
        console.log(res.data)
      })
    },
// 查询落地页Url\ID
    async dingxiang(parms){
      this.flagt=0;
      let time1 = parseInt(new Date().getTime()) + '';
      let parmm;
      let flag=0;
      const config = {
        headers:{
          'Authorization': "Bearer "+parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      if (this.sex !== "不限" || this.age.length !== 0 || this.RGOT === true) {
        parmm = {
          targetName: "定向包" + time1,
          targetDesc: '关于年龄和地域的定向包',
          immutable: '0',
          type: '1',
        };
        if (this.sex !== "不限") {
          parmm.sex = this.sex1;
        }
        if (this.age.length !== 0) {
          parmm.age = this.age2;
        }
        if (this.RGOT === true) {
          parmm.region = '350,197,230,351,231,199,232,353,233,354,234,355,235,356,236,357,237,358,238,359,239,118,119,11,12,13,15,18,360,481,240,361,482,241,362,483,120,242,363,121,364,243,122,365,123,366,245,124,367,246,125,368,247,369,248,8,21,22,23,24,29,370,250,372,251,373,252,253,375,254,377,30,48,49,50,51,52,53,54,56,57,58,285,286,287,200,201,289,203,204,205,206,207,208,60,209,61,62,63,64,65,66,68,69,290,291,292,293,294,210,211,212,213,215,216,217,218,70,219,71,76,77,220,221,223,224,346,225,347,348,227,349,228,81,229';
        }
      } else {
        this.flagt = 1;
      }




      ///?extensionType=2&dayBudget=155500&planName=123&dayLimit=1
      if(this.flagt===0){
        await axios.post('apis/v2/communal/target/add',qs.stringify(parmm,{allowDots: true}),config
        ).then(res => {
          console.log("aaaaaaaaaaaaaaaaaaa---------------aaaaaaaaaaaaaaaaaaaa")
          console.log(res.data.data.targetId)
          this.targetId=res.data.data.targetId

        })
      }
    },
    // 查询落地页Url\ID
    async queryWebsideId(parms){
      const config = {
        headers:{
          'Authorization': "Bearer "+parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      let parmm={
        pageType:7,
      }
      ///?extensionType=2&dayBudget=155500&planName=123&dayLimit=1
      await axios.post('apis/v2/communal/ad/sparkPageNew/list',qs.stringify(parmm),config
      ).then(res => {
        console.log(res.data.data[0].pageId)
        this.idsList[parms.id].pageId=res.data.data[0].pageId,
          this.idsList[parms.id].pageUrl=res.data.data[0].pageUrl,
          this.idsList[parms.id].ocpcType=res.data.data[0].ocpcType
      })
    },



    // 搭建计划api
    async plan(parms){
      let time1 = parseInt(new Date().getTime()) + '';

      const config = {
        headers:{
          'Authorization': "Bearer "+parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      let parmm={
        extensionType:3,
        // dayBudget:155500,
        planName:parms.name+time1+'_'+this.formLabelAlign.name,
        dayLimit:0
      }
      ///?extensionType=2&dayBudget=155500&planName=123&dayLimit=1
      await axios.post('apis/v3/plan/add',qs.stringify(parmm),config
      ).then(res => {
        this.idsList[parms.id].planId=res.data.data.planId
      })



    },
    // 搭建广告组api
    async ground(parms){
      let parmm;
      let time1 = parseInt(new Date().getTime()) + '';

      const config = {
        headers:{
          'Authorization': "Bearer "+parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      if(this.flagt===0){
        parmm={
          planId:parms.planId,
          adGroupName: parms.name+time1+'_'+this.formLabelAlign.name,

          // adSearchPremiumKwSaveDTOList:[{
          //   kwPackageType:1
          // }],
          billingType:5,
          dayLimit:0,
          extensionFlow:2,
          extensionType:3,
          instantAppId:parms.instantAppId,
          instantAppUrl:parms.deepUrl,
          // deepUrl:parms.deepUrl,
          flowScene:6,
          ocpcOptmType:0,
          defaultSecondStage:1,
          deepOcpcPrice:0,
          deepOcpcType:0,
          ocpcPrice:parms.ocpcPrice,
          ocpcType:22,
          pageType:0,
          pageUrl:parms.pageUrl,
          price:300,

          targetId:this.targetId
        }
      }else if (this.flagt===1){
        parmm={
          planId:parms.planId,
          adGroupName: parms.name+time1+'_'+this.formLabelAlign.name,

          // adSearchPremiumKwSaveDTOList:[{
          //   kwPackageType:1
          // }],
          billingType:5,
          dayLimit:0,
          extensionFlow:2,
          extensionType:3,
          instantAppId:parms.instantAppId,
          instantAppUrl:parms.deepUrl,
          // deepUrl:parms.deepUrl,
          flowScene:6,
          ocpcOptmType:0,
          defaultSecondStage:1,
          deepOcpcPrice:0,
          deepOcpcType:0,
          ocpcPrice:parms.ocpcPrice,
          ocpcType:22,
          pageType:0,
          pageUrl:parms.pageUrl,
          price:300,


        }
      }

      ///?extensionType=2&dayBudget=155500&planName=123&dayLimit=1
      await axios.post('apis/v3/group/add',qs.stringify(parmm),config
      ).then(res => {
        // console.log(?)
        console.log(res.data.data)

        console.log(res.data.data.adGroupId)
        this.idsList[parms.id].groundId=res.data.data.adGroupId

      })
    },
    // 创建广告api
    async guanggao(parms){
      const config = {
        headers:{
          'Authorization': "Bearer "+parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      console.log(parms.addList)
      let map =new Map;
      let add={
        'addList':parms.addList
      }
      map.set("addList",add)
      console.log("-----------------")
      console.log(qs.stringify(add))
      await axios.post('apis/v3/ad/batch',qs.stringify(add,{allowDots: true}),config
      ).then(res=>{

        console.log(res.data);
        //广告组ID

      })
    },

    async cxhguanggao(parms){
      const config = {
        headers:{
          'Authorization': "Bearer "+parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      console.log("---------程序化广告--------")
      console.log(qs.stringify(parms.paramcxh))
      await axios.post('apis/v3/ad/program/add',qs.stringify(parms.paramcxh,{allowDots: true}),config
      ).then(res=>{
        console.log("程序化广告")
        console.log(res.data);
        //广告组ID

      })
    },
    //获取时间方法
    //获取当前日期函数
    getNowFormatDate() {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0

      return `${year}-${month}-${strDate}`
    },
    //图片上传api
    async upload(ps){

      let num=100/this.fileList.length;

      for (let i=0;i<this.fileList.length;i++){
        let formData=new FormData()
        const config = {
          headers:{
            'Authorization': "Bearer "+ps.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        formData.append('files',this.fileList[i].raw)
        formData.append('matSpecId',this.formLabelAlign3.placeType[1])
        let map=new Map;
        map.set('files',formData)
        map.set('matSpecId',1)
          await axios.post('apis/v3/creative/material/communal/upload',
          formData,config).then(res=>{
          console.log(res.data.data.id);
          this.fileCode[i]=res.data.data.id;
          this.percentage=num*(i+1);
          // // console.log(res.data.data.fileCode);
          // // console.log(res.data.data.fileFullPath);
        })
      }
      if (this.percentage===100){
        this.$notify({
          title: 'success',
          message: '素材上传成功',
          type: 'success'
        });
      }

      console.log(this.fileCode);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。

    },

    async uploadVideo(ps){

      let num=100/this.VideofileList.length;

      for (let i=0;i<this.VideofileList.length;i++){
        let formData=new FormData()
        const config = {
          headers:{
            'Authorization': "Bearer "+ps.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        formData.append('files',this.VideofileList[i].raw)
        formData.append('matSpecId',this.formLabelAlign3.placeType[1])
        let map=new Map;
        map.set('files',formData)
        map.set('matSpecId',1)
        await axios.post('apis/v3/creative/material/communal/upload',
          formData,config).then(res=>{
          console.log(res.data.id);


          this.videofileCode[i]=res.data.data.id;
          this.percentage=num*(i+1);
          // // console.log(res.data.data.fileCode);
          // // console.log(res.data.data.fileFullPath);
        })
      }
      if (this.percentage===100){
        this.$notify({
          title: 'success',
          message: '素材上传成功',
          type: 'success'
        });
      }

      console.log(this.videofileCode);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。

    },

    change(){
      console.log(this.towName)
    },
    onChange(a, fileList) {
      console.log(this.fileList)
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      console.log(file)
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onChange2(a, fileList) {
      console.log(this.fileList)
      this.VideofileList = fileList;
    },
    handleRemove2(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview2(file) {


    },


  },
  created(){
    //自动加载indexs方法
    axios.get('https://test.nbweiou.cn/api/oppo/find_list_name',{
    }).then(
      res=>{
        this.listname=res.data
        console.log(this.listname)
      }
    )
  }
}
</script>
<style>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}


.box-card1 {
  position: absolute;
  top: 350px;
  bottom: 0;
  left: 0;
  right: 0;
  margin:0 auto;
  width: 40%;
}
.box-card000 {
  position: absolute;
  top: 480px;
  bottom: 0;
  left: 0;
  right: 0;
  margin:0 auto;
  width: 40%;
}
.box-card3 {
  position: absolute;
  top: 750px;
  bottom: 0;
  left: 0px;
  right: 0px;
  margin:0 auto;
  width: 40%;
}
.box-card {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed; bottom: 35px;right: 30px;
  width: 25%;
}
.box-cards {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed; top: 20px;left: 30px;
  width: 20%;
}
.jdt{
  margin:0 auto;
}
.el-icon-plus{
  width: 20px;
  height: 20px;
}
.test{
  width: 20px;
  height: 20px;
}

</style>

















// WEBPACK FOOTER //
// src/components/login/OpBatchXS.vue